<style>
    .ly-bill{
        padding: 8px;
    }
    .ly-bill-page{
        text-align: right;
        margin-top: 10px;
    }
    .ly-bill-oper .el-button{
        margin-left:10px;
    }
    .el-card {
        box-shadow: none;
    }
    .el-table {
        margin-top: 10px;
    }
</style>
<template>
    <div class="ly-bill">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="8">
                <h1 style="padding-top:5px;">{{pageName}}</h1>
            </el-col>
            <el-col :span="16" class="tr ly-bill-oper">
                <template v-for="(el,i) in buttonConfig">
                    <template v-if="el.type == 'LyButtonBatch'">
                        <ly-button-batch 
                            :rows="tableChangeRows" 
                            :config="el"
                            :key="'act_'+i"
                            @operDone="operationCallback"
                            >{{el.name}}</ly-button-batch>
                    </template>
                    <template v-if="el.type == 'LyButtonImport'">
                        <ly-button-import 
                            :api="el.json.api" 
                            :key="'act_'+i"
                            :callback="search"
                            :data="el.json.data">{{el.name}}</ly-button-import>
                    </template>
                    <template v-else-if="el.type == 'LyButtonExport'">
                        <ly-button-export 
                            :formdata="submitForm" 
                            :key="'act_'+i"
                            :ticket="el.json.ticket">{{el.name}}</ly-button-export>
                    </template>
                    <template v-else-if="el.type == 'LyButtonAdd'">&nbsp;
                        <el-button type="primary" size="small" :key="'act_'+i" @click="createHandle">
                            <i class="fa fa-plus"></i>&nbsp;{{el.name}}
                        </el-button>
                    </template>
                    <!-- 批量 start -->
                    <template v-else-if="el.type == 'LyBatchOperation'">
                        <ly-batch-operation 
                        :key="'act_'+i"
                        :rows="tableChangeRows" :json="el.json" @operDone="operationCallback">{{el.name}}</ly-batch-operation>
                    </template>
                    <!-- 批量  end  -->
                    <!-- 批量备注 start -->
                    <template v-else-if="el.type == 'LyButtonRemark'">
                        <ly-button-remark 
                        :key="'act_'+i"
                        :rows="tableChangeRows" :api="el.json.api">{{el.name}}</ly-button-remark>
                    </template>
                    <!-- 批量备注  end  -->
                    <!-- 批量发送金蝶 start -->
                    <template v-else-if="el.type == 'LyButtonKingdee'">
                        <ly-button-kingdee :key="'act_'+i"
                        :rows="tableChangeRows" :api="el.json.api" @sendKingdeeDone="sendKingdeeDone">{{el.name}}</ly-button-kingdee>
                     </template>
                    <!-- 批量发送金蝶  end  -->
                    <!-- 批量撤回金蝶 start -->
                    <template v-else-if="el.type == 'LyButtonBackdee'">
                        <ly-button-backdee :key="'act_'+i"
                        :rows="tableChangeRows" :api="el.json.api" @sendBackdeeDone="sendbackdeeDone">{{el.name}}</ly-button-backdee>
                     </template>
                    <!-- 批量撤回金蝶  end  -->
                    <!-- 路由跳转的按钮 start -->
                    <template v-else-if="el.type == 'LyRouterButton'"> 
                        <ly-router-button :key="'act_'+i" :route="el.json.route">
                            <i :class="el.json.icon" v-if="el.json.icon"></i> {{el.name}}
                        </ly-router-button>
                    </template>
                </template>
                <!-- <el-button type="primary" size="small" @click="createHandle"><i class="fa fa-plus"></i>&nbsp;新增{{pageName}}</el-button> -->
                    
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 筛选部分 start -->
        <el-card class="box-card mt10" ref="searchCard" v-if="searchConfig && searchConfig.length > 0">
            <Ly-search-form :config="searchConfig" ref="searchForm" @search="search"></Ly-search-form>
        </el-card>
        <!-- 筛选部分 end -->
        <!-- 数据列表 start -->
        <ly-table 
            v-if="isInit"
            :head="tableConfig.head" 
            :config="tableConfig.config"
            :buttons="tableConfig.buttons"
            :data="tableData" 
            :has-btn="true"
            :loading="loading"
            :width="(tableConfig.config && tableConfig.config.width) ? tableConfig.config.width : '100%'"
            @click="tableClick" 
            @change="tableChange"
            ref="searchTable">
        </ly-table>
        <!-- 数据列表 end -->
        <!-- 分页 start -->
        <div class="ly-bill-page" v-if="submitForm.page">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                  :current-page="submitForm.page"
                  :page-sizes="[10, 20, 30, 40, 50]"
                  :page-size="submitForm.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalPage">
            </el-pagination>
        </div>
        <!-- 分页 end -->
    </div>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex'
    import LyDatePicker from '@c/date_picker'
    import LySelect from '@c/select'
    import LyTable from '@c/table'
    import LySearchForm from '@c/search-form'
    import LyButtonExport from '@c/button-export'
    import LyButtonImport from '@c/button-import'
    import LyButtonRemark from '@c/button-remark'
    import LyRouterButton from '@c/router-button'
    import LyButtonKingdee from '@c/button-kingdee'
    import LyButtonBackdee from '@c/button-backdee'
    import LyBatchOperation from '@c/batch-operation'
    import LyButtonBatch from '@c/button-batch'
    export default {
        name: 'LyBillList',
        components: {
            LyDatePicker, 
            LySelect, 
            LyTable, 
            LySearchForm,
            LyButtonExport,
            LyButtonImport,
            LyButtonRemark,
            LyRouterButton,
            LyBatchOperation,
            LyButtonKingdee,
            LyButtonBatch,
            LyButtonBackdee
        },
        computed: {
            ...mapGetters('route', [
                'currRoute'
            ]),
            ...mapGetters('bill', [
                'searchForm'
            ])
        },
        data () {
            return {
                isInit: false, // 标注页面是否初始化完成
                cardWidth: '',
                pageName: '', // 当前页面的名称
                searchConfig: [], // 搜索组件配置
                tableConfig: {}, // 表格相关配置
                buttonConfig: {}, // 按钮的配置
                // 查询提交时的表单数据
                submitForm: {},
                tableData: [], // 表格的数据
                totalPage: 0, // 总条数
                loading: false,
                // 表格选择的行
                // 2018-05-17添加，批量备注用到
                tableChangeRows: []
            }
        },
        mounted () {
            // 获得card得宽度
            // this.cardWidth = this.$refs['searchCard'].$vnode.elm.clientWidth + 'px'
            this.readRouteConfig()
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'BillList') {
                    this.searchConfig = [] // 搜索相关至空
                    this.tableConfig = {} // 表格相关配置
                    this.isInit = false
                    this.$nextTick(() => {
                        this.readRouteConfig()
                    })
                }
            }
        },
        methods: {
            ...mapActions('route', [
                'updateCurrRoute'
            ]),
            ...mapActions('bill', [
                'setPageSearchForm'
            ]),
            /**
             * 提交表单的初始化
             * @param  {[Number]} page [当前分页]
             * @param  {[Number]} size [每页的条数]
             */
            initSubmitForm (page, size) {
                this.submitForm['page'] = page // 当前分页
                this.submitForm['size'] = size // 每页的条数
            },
            /**
             * 数据的获取
             */
            queryData () {
                this.loading = true
                // let data = Object.assign({}, this.submitForm)
                // 获得查询条件内容
                // let searchField = data.searchField
                // 将searchField中的对象转为一维
                for (let i in this.submitForm) {
                    if (typeof this.submitForm[i] === 'object') {
                        for (let key in this.submitForm[i]) { // 遍历对象中的字段
                            // 将对象中的key value 设置到 searchField
                            this.submitForm[key] = this.submitForm[i][key]
                        }
                        delete this.submitForm[i]
                    }
                }
                // 记录此页面的搜索数据
                this.setPageSearchForm(this.submitForm)
                // console.log('this.submitForm:%O', data)
                let data = Object.assign({}, this.submitForm)
                // 移除空字段
                for (let i in data) {
                    if (!data[i] || data[i].length <= 0) {
                        delete data[i]
                    }
                }
                this.$api.query(this.currRoute.api, data).then((rs) => {
                    console.log('data:', rs)
                    this.totalPage = rs.total // 总条数
                    this.tableData = rs.data || [] // 列表数据
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },
            /**
             * 读取路由的配置
             */
            readRouteConfig () {
                // 设置信的submitForm对象
                this.submitForm = {}
                if (location.href.indexOf('fuzhudz/list') > 0) {
                    // 获得当前页面的配置
                    let routeConfig = this.$utils.readRouteConfig('/bill/fuzhudz/list')
                    // 更新当前路由对象
                    this.updateCurrRoute(routeConfig)
                }
                // 获得页面配置
                let config = this.$utils.readPageConfig(this.currRoute, 'list')
                // 当前页面的组件配置
                config = config ? config.config : null
                // 获得当前页面的名称
                this.pageName = this.currRoute ? this.currRoute.name : ''
                if (config) {
                    // 按钮的配置
                    this.buttonConfig = config.buttons ? JSON.parse(config.buttons || '') : {}
                    // 搜索组件配置
                    this.searchConfig = (config.search && config.search.length > 2) ? config.search : []
                    // 获得表格配置
                    this.tableConfig = JSON.parse(config.table || '')
                    setTimeout(() => {
                        this.isInit = true
                    }, 100)
                    // 初始化设置searchForm
                    if (!this.searchForm[this.currRoute.path]) { // 无存储的状态，直接初始化
                        this.initSubmitForm(1, 20)
                        this.search()
                    } else { // 如果有当前页面的数据，设置到表单上
                        setTimeout(() => {
                            let storeSearchForm = this.searchForm[this.currRoute.path]
                            this.initSubmitForm(storeSearchForm.page, storeSearchForm.size)
                            if (this.$refs['searchForm']) {
                                this.$refs['searchForm'].initBindFormData(storeSearchForm) // 初始化表单中的值
                            }
                            // 表单数据的处理
                            this.bindToSubmit()
                            // 查询数据
                            this.queryData()
                        }, 100)
                    }
                    // 查找数据
                } else {                    
                    this.$alert('请重试 或 询问管理员是否为你授权', '未检测到当前页面配置', {
                        confirmButtonText: '确定',
                          callback: action => {
                                // 4、路由跳转到默认页面
                                // this.$router.replace('/')
                          }
                    });
                }
            },
            /**
             * 新增操作的监听
             */
            createHandle () {
                // 跳转到的路由
                let path = '/bill/' + this.currRoute.path + '/add'
                this.$router.push(path)
            },
            /**
             * 搜索的监听
             */
            search () {
                // 这里fieldList第一次获取时，表格可能还没渲染好，通过定时轮询获取，直到fieldList有值
                // let inter = setInterval(() => {
                //     if (this.submitForm.dataField && this.submitForm.dataField.length > 0) {
                //         clearInterval(inter)
                //         // 从第一页开始查询
                //         this.handleCurrentChange(1)
                //     } else {
                //         this.bindToSubmit()
                //     }
                // }, 100)
                this.bindToSubmit()
                // 从第一页开始查询
                this.handleCurrentChange(1)
            },
            /**
             * 将表单绑定的值传递到提交表单中
             */
            bindToSubmit () {
                // 表单中设置路由名
                this.submitForm['route'] = this.currRoute.path
                // 获得需要的字段
                // this.submitForm['dataField'] = this.$refs['searchTable'].fieldList || []
                // 得查询的字段
                // this.submitForm['searchField'] = this.$refs['searchForm'].bindForm
                if (this.$refs['searchForm']) {
                    this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                }
            },
            /**
             * 每页条数选择监听
             */
            handleSizeChange (val) {
                this.initSubmitForm(1, val)
                this.queryData()
            },
            /**
             * 分页监听
             */
            handleCurrentChange (val) {
                this.submitForm.page = val
                this.queryData()
            },
            /**
             * table 操作按钮的点击
             * @param  {[String]} mark  [按钮标识]
             * @param  {[Number]} index [当前点击的行索引]
             * @param  {[Object]} row   [当前行的数据对象]
             */
            tableClick (mark, index, row) {
                if (mark === 'delete') {
                    this.$confirm('确认将此条记录删除吗?', '记录删除提醒', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.deleteRow(index, row)
                    })
                } else if (mark === 'failure') {
                    this.$confirm('确认将此条记录置为失效吗?', '记录失效提醒', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.failureRpw(index, row)
                    })
                } else {
                    // 跳转到的路由 39批 辅助对账列表查看详情跳转调整  2018.8.22
                    if (this.currRoute.path === 'fuzhudz') {
                        this.currRoute.path = 'payconfirm'                        
                        // 获得当前页面的配置
                        let routeConfig = this.$utils.readRouteConfig('/bill/payconfirm/list')
                        // 更新当前路由对象
                        this.updateCurrRoute(routeConfig)
                    } 
                    let path = '/bill/' + this.currRoute.path + '/' + mark + '/' + row.id
                    this.$router.push(path)
                }
            },
            /**
            * 失效一行数据
            * @param  {[Object]} row [行数据]
            */
            failureRpw (index, row) {
                this.$api.delete(this.currRoute.api, null, [row.id]).then((rs) => {
                    this.queryData()
                    this.$message({
                        message: '置为失效成功',
                        type: 'success'
                    })
                }).catch((error) => {                    
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 删除一行数据
             * @param  {[Object]} row [行数据]
             */
            deleteRow (index, row) {
                this.$api.delete(this.currRoute.api, null, [row.id]).then((rs) => {
                    this.tableData.splice(index, 1)
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                }).catch((error) => {                    
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 表格的选择
             * @return {[type]} [description]
             */
            tableChange (row) {
                this.tableChangeRows = row
            },
            operationCallback () {
                // 清空表格的选择
                this.tableChangeRows = []
                // 重新获得一次数据
                this.queryData()
            },
            /**
             * 批量发送金蝶的回调处理
             */
            sendKingdeeDone () {
                // 清空表格的选择
                this.tableChangeRows = []
                // 重新获得一次数据
                this.queryData()
            },
            /** 
            * 批量撤回金蝶
            */
            sendBackdeeDone () {
                // 清空表格的选择
                this.tableChangeRows = []
                // 重新获得一次数据
                this.queryData()
            }
        }
    }
</script>